import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/pages/Admin/Authentication.scss';
import SERVER from '../../hooks/useServer';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email) {
            toast.error('Veuillez entrer votre email');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${SERVER}/auth/forgot-password`, { email });
            toast.success(response.data.message);
            setEmail('');
        } catch (err) {
            toast.error(err.response?.data?.error || 'Échec de l\'envoi de l\'email. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='auth'>
            <div className="auth-container">
                <div className="auth-header">
                    <h1>Mot de passe oublié</h1>
                    <h3>Entrez votre email pour recevoir un lien de réinitialisation</h3>
                </div>

                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Entrez votre email"
                            required
                            disabled={loading}
                        />
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading} 
                        className={`auth-button ${loading ? 'loading' : ''}`}
                    >
                        {loading ? (
                            <>
                                <span className="spinner"></span>
                                Envoi en cours...
                            </>
                        ) : (
                            'Envoyer le lien'
                        )}
                    </button>

                    <div className="back-link">
                        <Link to="/admin/login">← Retour à la connexion</Link>
                    </div>
                </form>
            </div>
            <ToastContainer position="bottom-right" autoClose={3000} />
        </div>
    );
};

export default ForgotPassword;
